import { createSlice } from '@reduxjs/toolkit';
import { fetchOneVillage, fetchVillages, fetchVillagesByCell } from '../thunks/village.thunk';

interface IVillage {
  id: string;
  name: string;
  pollingStationId?: number | null;
  noVotingBureaus?: number | null;
  cell?: {
    id: string | null;
  };
}

interface VillageState {
  allVillages: IVillage[];
  villagesByCell: IVillage[];
  selectedVillage: IVillage | null;
  count: number;
  pages: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
}

const initialState: VillageState = {
  allVillages: [],
  villagesByCell: [],
  selectedVillage: null,
  count: 0,
  pages: 0,
  page: 1,
  limit: 10,
  loading: false,
  error: null
};

const villageSlice = createSlice({
  name: 'villages',
  initialState,
  reducers: {
    resetVillages: (state) => {
      state.villagesByCell = [];
    },
    clearSelectedVillage: (state) => {
      state.selectedVillage = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchVillages.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVillages.fulfilled, (state, action) => {
        state.loading = false;
        state.allVillages = action.payload.items;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchVillages.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch villages';
      })
      .addCase(fetchVillagesByCell.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchVillagesByCell.fulfilled, (state, action) => {
        state.loading = false;
        state.villagesByCell = action.payload;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchVillagesByCell.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch villages by cell';
      })
      // Cases for fetchOneVillage
      .addCase(fetchOneVillage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.selectedVillage = null;
      })
      .addCase(fetchOneVillage.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedVillage = action.payload;
      })
      .addCase(fetchOneVillage.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch village';
      });
  }
});

export const { resetVillages, clearSelectedVillage } = villageSlice.actions;
export const villageReducer = villageSlice.reducer;
